import React, { JSX } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Typography,
  CheckboxProps,
} from "@mui/material";
import { colors } from "../../../../styles/theme";

export type LabeledCheckboxProps = {
  text: string;
  error?: string;
  value: boolean;
} & Omit<CheckboxProps, "checked">;

export const LabeledCheckbox: React.FC<LabeledCheckboxProps> = (
  props
): JSX.Element => {
  const { text, error, value, ...checkboxProps } = props;
  const hasError = Boolean(error);

  return (
    <FormControl error={hasError} component="fieldset" variant="standard">
      <FormControlLabel
        control={
          <Checkbox
            checked={value}
            {...checkboxProps}
          />
        }
        label={
          <Typography
            variant="v2"
            sx={{
              color: colors.text.v3,
            }}
          >
            {text}
          </Typography>
        }
      />
      {hasError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
